import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import { useAuth } from '../contexts/AuthContext';
import { JOB_TYPE_LABELS } from '../constants/jobTypes';

const CATEGORY_LABELS = {
  'legal': '法律合规', 'finance': '财务审计', 'business': '商务拓展',
  'engineering': '工程技术', 'hr': '人力资源', 'supply-chain': '供应链', 'other': '其他',
};
const CATEGORY_ICONS = {
  'legal': '⚖️', 'finance': '💰', 'business': '🌐',
  'engineering': '🏗️', 'hr': '📋', 'supply-chain': '📦', 'other': '📄',
};

function MyFavorites() {
  const { user } = useAuth();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    api.get('/jobs/my/favorites')
      .then(res => setJobs(res.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [user]);

  const handleRemove = async (id) => {
    if (!window.confirm('确定要取消收藏吗？')) return;
    try {
      await api.post(`/jobs/${id}/favorite`);
      setJobs(jobs.filter(j => j.id !== id));
    } catch {
      alert('操作失败');
    }
  };

  if (!user) {
    return (
      <div className="container" style={{ paddingTop: 60, textAlign: 'center' }}>
        <p>请先 <Link to="/login" style={{ color: 'var(--primary)' }}>登录</Link></p>
      </div>
    );
  }

  return (
    <div className="container" style={{ paddingTop: 20, paddingBottom: 60 }}>
      <div className="page-header">
        <h1 className="page-title">我的收藏</h1>
        <p className="page-subtitle">你收藏的 {jobs.length} 个岗位</p>
      </div>

      {loading ? (
        <div className="loading">加载中...</div>
      ) : jobs.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">☆</div>
          <p className="empty-state-text">你还没有收藏任何岗位</p>
          <Link to="/jobs" className="btn btn-primary">去看看岗位</Link>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {jobs.map(job => (
            <Link key={job.id} to={`/jobs/${job.id}`} style={{ textDecoration: 'none' }}>
              <div className="card card-clickable job-card">
                <div className="job-card-icon">{CATEGORY_ICONS[job.category] || '📄'}</div>
                <div className="job-card-content">
                  <div className="job-card-title">{job.title}</div>
                  <div className="job-card-company">{job.company}</div>
                  <div style={{ fontSize: '0.85rem', color: 'var(--text-light)', margin: '4px 0' }}>
                    📍 {job.location}
                    {job.publishDate && <span style={{ marginLeft: 12 }}>📅 {job.publishDate}</span>}
                  </div>
                  <div className="job-card-meta">
                    <span className="tag">{JOB_TYPE_LABELS[job.jobType] || job.jobType}</span>
                    <span className="tag tag-purple">{CATEGORY_LABELS[job.category] || job.category}</span>
                  </div>
                  <div className="job-card-footer">
                    <span>{job.salary || '薪资面议'}</span>
                    <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      {job.viewCount || 0} 次查看 · {job.commentCount || 0} 条评论
                      <button
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleRemove(job.id); }}
                        title="取消收藏"
                        style={{
                          background: 'none', border: 'none', cursor: 'pointer',
                          fontSize: '1.05rem', padding: 0, color: 'var(--error, #e53e3e)',
                        }}
                      >★</button>
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

export default MyFavorites;
